import {
    fetchRecalculatedGraphSplit,
    fetchRecalculatedGraphTopics,
} from '../hooks/useApi'
import { applyTopicsExtensionToGraph } from './graphTopics'

export const runGraphRecalculation = async ({
    contextName,
    filteredStatementIds = [],
    stopWords = [],
    userName = null,
    synthesisType = null,
    searchTerms = null,
    additionalContexts = [],
    comparisonMode = null,
    precomputedGraphData = null,
    onGraphData,
    onTopicsApplied,
}) => {
    let graphData
    let topicsPromise

    if (precomputedGraphData) {
        // graph already supplied (mutation paths) — skip the graph fetch, topics only
        graphData = precomputedGraphData
        topicsPromise = fetchRecalculatedGraphTopics(
            contextName,
            filteredStatementIds,
            stopWords,
            userName,
            synthesisType,
            searchTerms,
            additionalContexts,
            comparisonMode
        )
            .then(data => data?.topicsExtension || null)
            .catch(error => {
                console.error('Error fetching AI topics extension:', error)
                return null
            })
    } else {
        ;({ graphData, topicsPromise } = await fetchRecalculatedGraphSplit(
            contextName,
            filteredStatementIds,
            stopWords,
            userName,
            synthesisType,
            searchTerms,
            additionalContexts,
            comparisonMode
        ))
    }

    if (onGraphData) {
        await onGraphData(graphData)
    }

    const topicsTask = topicsPromise
        .then(topicsExtension => {
            if (!topicsExtension) {
                return null
            }

            const graphWithTopics = applyTopicsExtensionToGraph(
                graphData,
                topicsExtension
            )

            if (onTopicsApplied) {
                return Promise.resolve(
                    onTopicsApplied(graphWithTopics, topicsExtension)
                ).then(() => ({ graphWithTopics, topicsExtension }))
            }

            return { graphWithTopics, topicsExtension }
        })
        .catch(error => {
            console.error(
                '[runGraphRecalculation] Topics update failed:',
                error
            )
            return null
        })

    return { graphData, topicsPromise: topicsTask }
}
